import router from '../router'

//网络请求
import Axios from 'axios'
Axios.defaults.baseURL = '/seller-api'

//拦截
Axios.interceptors.request.use(
    config => {
      const Token = localStorage.getItem(`token`);
      const Size = localStorage.getItem('Size');
      const project_id = localStorage.getItem('current_project_id');
      config.headers = {
          'Content-Type':'application/json',
          'X-Token':Token,
          'X-Size':Size,
          'X-Project-id':project_id,
          'X-Client':'pc',
      }
      return config;
    },
    err => {
        return Promise.reject(err);
    }
)
Axios.interceptors.response.use(
    response => {
      if (response.data.code == 10036) {
        if ( ['Sign', 'PrivacyPolicy', 'FAQ', 'AboutUs', 'Tutorial', 'ScreencastVideo'].indexOf(router.currentRoute.name) == -1 ) {
            router.replace({
                path: '/sign?a=from_axios',
                query: {redirect: router.currentRoute.fullPath}
            })
        }
      } 
      return response;
    },
    error => {
        // return Promise.reject(error.response.data);
    }
)

export default Axios



// WEBPACK FOOTER //
// ./src/util/Axios.js